import IDokument from "../ts/IDokument";
import URLEndPointBE from "./URLEndPointBE";

function HandleDokument(props: any) {
    //console.log(props)
    switch(props.state) {
        case 'INSERT':
            return <span className="documentUploadStyle">
                tmpDok. #{props.arr_idx}
                <span className='katBtnStyle ptHover' onClick={(e: any)=>props.handle_smazat_dokument(props.arr_idx)}>x</span>
                </span>;
        case 'VIEWING':
            return <span className="documentUploadStyle">
                DOKUMENT #{props.dokumentId}
                <span className='katBtnStyle ptHover' onClick={(e: any)=>props.handle_smazat_dokument(props.arr_idx)}>x</span>
                </span>;
        case 'DELETE':
            return<></>;
        default:
            return <></>    
    }
}
export default HandleDokument